import { FC, ReactNode, Dispatch, createContext, useContext, useReducer } from "react";
import { AlertVariant } from "@patternfly/react-core";

// Context to handle the alert popup
interface IAlertItem {
  title: string;
  description?: string;
  variant: AlertVariant;
  actionLinks?: ReactNode[];
  id?: string;
}
interface IAlertState {
  alertState: IAlertItem[];
}
export enum AlertActionType {
  SHOW = "SHOW",
  HIDE = "HIDE"
}

const getUniqueId = () => (new Date().getTime().toString());

const AlertReducer = (state: IAlertState, action: any) => {
  switch (action.type) {
    case AlertActionType.SHOW: {
      action.payload.id = getUniqueId();
      return {
        ...state,
        alertState: [...state.alertState, action.payload]
      };
    }
    case AlertActionType.HIDE: {
      return {
        alertState: state.alertState.filter(item => item.id !== action.payload.id)
      };
    }
    default:
      return state;
  }
};

interface IAlertDispatch {
  type: AlertActionType,
  payload: IAlertItem
}

interface IAlertContext {
  state: IAlertState,
  setAlertState?: Dispatch<IAlertDispatch>;
}
const initialAlertState: IAlertState = {
  alertState: []
};

const initialAlertContext: IAlertContext = {
  state: initialAlertState
};

const AlertContext = createContext<IAlertContext>(initialAlertContext);
export const useAlertContext = () => useContext(AlertContext);

interface AlertProviderProps {
  children?: ReactNode;
}
const AlertProvider: FC<AlertProviderProps> = props => {
  const [state, dispatch] = useReducer(AlertReducer, initialAlertState);
  return (
    <AlertContext.Provider value={{state, setAlertState: dispatch}}>
      {props.children}
    </AlertContext.Provider>
  );
};

export default AlertProvider;

export function ErrorPopup(context, title?: string, description?: string, actionLinks?: ReactNode[]) {
  context({
    type: AlertActionType.SHOW,
    payload: {
      title:  title ? title : "There was an error submitting the form",
      description: description ? description : "",
      variant: AlertVariant.danger,
      actionLinks: actionLinks ? actionLinks : [],
    }
  });
}


export function SuccessPopup(context, title?: string, description?: string, actionLinks?: ReactNode[]) {
  context({
    type: AlertActionType.SHOW,
    payload: {
      title:  title ? title : "Success",
      description: description ? description : "",
      variant: AlertVariant.success,
      actionLinks: actionLinks ? actionLinks : []
    }
  });
}

export function WarningPopup(context, title?: string, description?: string, actionLinks?: ReactNode[]) {
  context({
    type: AlertActionType.SHOW,
    payload: {
      title:  title ? title : "Warning",
      description: description ? description : "",
      variant: AlertVariant.warning,
      actionLinks: actionLinks ? actionLinks : []
    }
  });
}

export function InfoPopup(context, title?: string, description?: string, actionLinks?: ReactNode[]) {
  context({
    type: AlertActionType.SHOW,
    payload: {
      title:  title ? title : "Info",
      description: description ? description : "",
      variant: AlertVariant.info,
      actionLinks: actionLinks ? actionLinks : [],
    }
  });
}